export const getSaleFrameSrc = (templatesData, templateId) => {
  const optionsEditorCfg = getOptionsEditorCfg(templatesData, templateId);

  return optionsEditorCfg && optionsEditorCfg.saleFrameSrc;
};

export const getLeaseFrameSrc = (templatesData, templateId) => {
  const optionsEditorCfg = getOptionsEditorCfg(templatesData, templateId);

  return optionsEditorCfg && optionsEditorCfg.leaseFrameSrc;
};

export const getOptionsEditorCfg = (templatesData, templateId, propertyType = null) => {
  const templateData = getTemplateData(templatesData, templateId);
  const optionsEditorCfg = templateData && templateData.optionsEditorCfg; // May be null

  if (propertyType === 'sale') {
    optionsEditorCfg.data = optionsEditorCfg.saleData;
  } else if (propertyType === 'lease') {
    optionsEditorCfg.data = optionsEditorCfg.leaseData;
  }

  return optionsEditorCfg;
};

export const getTemplateData = (templatesData, templateId) => {
  return (templatesData || []).find(templateData => templateData.template.id === templateId);
};
